import { render, staticRenderFns } from "./CoachsPicturesFilters.vue?vue&type=template&id=bdb353cc"
import script from "./CoachsPicturesFilters.vue?vue&type=script&lang=js"
export * from "./CoachsPicturesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports